import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { i18n } from '@lingui/core'
import { motion } from 'framer-motion'
import { isNil } from 'ramda'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { NativePlatform, WebPlatform } from '@/capacitor/components/native-platform/NativePlatform'
import { globalDefinitions } from '@/defined-translations'
import {
  StAnimatedBackButton,
  StBody,
  StButtonContainer,
  StContainer,
  StContent,
  StContentContainer,
  StImage,
} from './QuestionnaireHeroContent.styled'

import type { ReactElement, ReactNode } from 'react'

type Props = {
  title: string
  description?: ReactElement | string
  image: string
  onGoBack?: () => void
  buttons?: ReactNode
}

const QuestionnaireHeroContent = ({ title, description, image, onGoBack, buttons }: Props) => (
  <StContainer>
    <StContentContainer>
      <StImage imgSrc={image} />
      <StContent>
        {onGoBack ? (
          <StAnimatedBackButton
            key={'back-button'}
            initial={{
              opacity: 0,
              x: -30,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            exit={{ opacity: 0, x: -30 }}
            transition={{ type: 'spring', bounce: 0.1, duration: 0.4 }}
            onClick={onGoBack}
          >
            <FontAwesomeIcon icon={['far', 'chevron-left']} fontSize={13} />
            <Span type='BodyMediumBold'>{i18n._(globalDefinitions.goBack)}</Span>
          </StAnimatedBackButton>
        ) : null}
        <StBody>
          <H3 noMargin>{title}</H3>
          <Span type='BodyLargeRegular'>{description}</Span>
          <WebPlatform>{isNil(buttons) ? null : <StButtonContainer>{buttons}</StButtonContainer>}</WebPlatform>
        </StBody>
      </StContent>
    </StContentContainer>
    <NativePlatform>{isNil(buttons) ? null : <StButtonContainer>{buttons}</StButtonContainer>}</NativePlatform>
  </StContainer>
)

const AnimatedQuestionnaireHeroContent = motion(QuestionnaireHeroContent)

export { AnimatedQuestionnaireHeroContent, QuestionnaireHeroContent }
